// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","732":"35ed01f5","755":"a69d4360","977":"6a7f6471"}[chunkId] + ".chunk.js";
};